<template>
  <el-row class="mt-7 pb-9">
    <el-col class="mb-2 text-center">
      <img class="py-4" src="/favicon.ico" alt="QuoteWizard Icon" />
      <h2>Reactivation Complete</h2>
      <h5>We're glad to have you back, {{ clientFirstName }}!</h5>
      <el-button class="my-2" type="primary" @click="$emit('click-finish')"> Finish </el-button>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReactivationComplete',
  computed: {
    ...mapGetters('client', ['clientFirstName']),
  },
};
</script>

<style scoped></style>
